<template>
  <div class="container mt-5">
    <div class="row align-middle align-items-center mb-3">
      <div class="col-md-11">
        <input class="form-control" v-model="query" @input="searchInput" />
      </div>
      <div class="col-md-1">
        <button type="button" class="btn" :class="{'btn-secondary': settingsOpen, 'btn-outline-secondary': !settingsOpen}" @click="settingsOpen = !settingsOpen">Settings</button>
      </div>
    </div>

    <div class="settings" v-if="settingsOpen">

      <label for="" class="form-label">API Key</label>
<input type="text" id="" class="form-control" v-model="key" @input="apiKeyChange">
<div id="" class="form-text">
  OMDB API key. If you don't know what this is, don't touch it.
</div>

    </div>

    <div class="row">
      <div class="col-md-2 mt-3" v-for="movie in movies" :key="movie.imdbID">
        <div class="card hh">
          <img :src="movie.Poster" v-if="movie.Poster !== 'N/A'" class="card-img-top" :alt="movie.Title">
          <div class="card-body">
            <span class="badge bg-secondary mb-2">{{ movie.Year | yearCut }}</span>
            <h6 class="card-title"><router-link class="text-white tdn" :to="'movie/' + movie.imdbID">{{  movie.Title }}</router-link></h6>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Movies',
    data() {
      return {
        query: "",
        key: "",
        settingsOpen: false,
        movies: {"Search":[{"Title":"Star Trek","Year":"2009","imdbID":"tt0796366","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BMjE5NDQ5OTE4Ml5BMl5BanBnXkFtZTcwOTE3NDIzMw@@._V1_SX300.jpg"},{"Title":"Star Trek Into Darkness","Year":"2013","imdbID":"tt1408101","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BMTk2NzczOTgxNF5BMl5BanBnXkFtZTcwODQ5ODczOQ@@._V1_SX300.jpg"},{"Title":"Star Trek Beyond","Year":"2016","imdbID":"tt2660888","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BNDc2YThlMTgtN2M3Yi00YzkxLWE4MDQtMWJmYmZiNTNjNjJlXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek: First Contact","Year":"1996","imdbID":"tt0117731","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BYzMzZmE3MTItODYzYy00YWI5LWFkNWMtZTY5NmU2MDkxYWI1XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek II: The Wrath of Khan","Year":"1982","imdbID":"tt0084726","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BNmZiZmM2OTUtZDlmOC00YzYyLThkMGEtZWFkMjJmM2EwZDVkXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek: The Motion Picture","Year":"1979","imdbID":"tt0079945","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BNjk1ZjAyZjktZTY4YS00NDY3LWIwMzktMjZiNGIzODFiZDVmXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek IV: The Voyage Home","Year":"1986","imdbID":"tt0092007","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BZmU3ZGE3NzEtYTdmYi00YTYxLWIxYTItZGY5YjFlOTA2NWI3XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek: Generations","Year":"1994","imdbID":"tt0111280","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BOTk5Mjg4MzktZTczNC00ZWI3LWFlNjgtNjgwZDQwOGU5NmQ3XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek III: The Search for Spock","Year":"1984","imdbID":"tt0088170","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BMmFiMTczYjgtMWQwOC00MjFlLWFlZjUtMjJjNTcxNjAzY2Q1XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg"},{"Title":"Star Trek: Nemesis","Year":"2002","imdbID":"tt0253754","Type":"movie","Poster":"https://m.media-amazon.com/images/M/MV5BMjAxNjY2NDY3NF5BMl5BanBnXkFtZTcwMjA0MTEzMw@@._V1_SX300.jpg"}],"totalResults":"351","Response":"True"}.Search
      }
    },
    filters: {
      yearCut(year) {
        return year.substr(0, 4)
      }
    },
    computed: {
    },
    methods: {
      apiKeyChange() {
        localStorage['omdbKey'] = this.key;        
      },
      search(query) {
        const url = new URL('https://www.omdbapi.com/');
        const params = {
          apikey: this.key,
          type: 'movie',
          s: query
        }
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        return fetch(url).then(res => res.json()).catch((err) => {
          alert("Error! " + err.toString());
        });
      },
      searchInput() {
        if (this.query.length >= 3) {
          this.search(this.query).then((res) => {
            this.movies = res.Search;
          });
        }
      }
    },
    mounted() {

      if(typeof localStorage['omdbKey'] == 'undefined') {
        localStorage['omdbKey'] = '22c67895';
      }

      this.key = localStorage['omdbKey'];    

    },
    components: {
    }
  }
</script>

<style scoped>
.hh {
  height: 100%;
}
.popover {
  background: #000 !important;
  color: #fff;
}
.tdn {
  text-decoration: none;
}
.tdn:hover {
  text-decoration: underline;
}
</style>